<script setup lang="ts">
import { onLaunch } from '@dcloudio/uni-app'
import { useSettingsStore } from './stores/settings'

onLaunch(() => {
  const settingsStore = useSettingsStore()
  settingsStore.applyTheme()

  let hasAuth = false
  try {
    const raw = uni.getStorageSync('devword_auth')
    if (raw) {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
      if (parsed?.token && (typeof parsed.exp !== 'number' || Date.now() <= parsed.exp)) {
        hasAuth = true
      } else {
        uni.removeStorageSync('devword_auth')
      }
    }
  } catch {
    hasAuth = false
  }

  const pages = getCurrentPages()
  const current = pages.length ? pages[pages.length - 1].route : 'pages/login/index'

  if (!hasAuth && current !== 'pages/login/index') {
    uni.reLaunch({ url: '/pages/login/index' })
  } else if (hasAuth && current === 'pages/login/index') {
    uni.reLaunch({ url: '/pages/home/index' })
  }
})
</script>

<style>
@import './styles/theme.css';
@import './styles/global.css';
</style>
